import * as React from "react";
import styled from "styled-components";
import { Timestamp } from "components/common";
const Separator = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 20px 0;
  font-size: ${({ theme }) => theme.fonts.size.small};
  white-space: nowrap;

  &::before,
  &::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid;
  }

  &:empty::after {
    display: none;
  }
`;
const TimestampSeparator = ({ timestamp = void 0 }) => /* @__PURE__ */ React.createElement(Separator, null, timestamp && /* @__PURE__ */ React.createElement(Timestamp, { dateTime: timestamp, format: "dateHourAndMinute" }));
export default TimestampSeparator;
